

require("@/assets/css/_index.scss");
if (process.env.VUE_APP_SYSTEM_LOCALE == "ko") {
  require("@/assets/css/style.ko.css");
}
if (process.env.VUE_APP_SYSTEM_LOCALE == "global") {
  require("@/assets/css/global.scss");
  require("@/assets/css/style.global.scss");
}
import "@/assets/css/nprogress-custom.css";
import axios, { AxiosStatic } from "axios";
import { loadProgressBar } from "axios-progress-bar";
import "firebase/analytics";
import firebase from "firebase/app";
import "popstate-direction";
import PortalVue from "portal-vue";
import "swiper/css/swiper.css";
import DropdownMenu from "v-dropdown-menu";
import mobileDeviceDetect, { isMobile } from "mobile-device-detect";
import CommonUtils from "../src/common-utils";
import "v-dropdown-menu/dist/v-dropdown-menu.css"; // Base style, required.
import "video.js/dist/video-js.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VueI18n from "vue-i18n";
import infiniteScroll from "vue-infinite-scroll";
import VueKakaoSdk from "vue-kakao-sdk";
import VueMeta from "vue-meta";
import VueOverflowScroll from "vue-overflow-scroll";
import { Component, Vue, Watch } from "vue-property-decorator";
import ReadMore from "vue-read-more";
import VueScrollTo from "vue-scrollto";
import TextareaAutosize from "vue-textarea-autosize";
import VueVideoPlayer from "vue-video-player";
import Toast from "vue2-toast";
import "vue2-toast/lib/toast.css";
import CommonPopup from "./components/CommonPopup.vue";
import DiscountRate from "./components/DiscountRate.vue";
import MainSubCurrency from "./components/MainSubCurrency.vue";
import Constants from "./constants";
import Layout from "./views/biz/main/Layout.vue";
import numeral from "numeral";
import VueSession from "vue-session";
import { RecentProductVO } from "./views/biz/product/vo/product.vo";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import VueGtag from 'vue-gtag'
import router from "./router/router";

require("@/assets/js/rn-webview-bridge");

declare module "vue/types/vue" {
  interface Vue {
    $toast(message: string | VueI18n.TranslateResult): void;
    $toast(message: string | VueI18n.TranslateResult, options: object): void;
    $analytics: firebase.analytics.Analytics;
    $scrollToTop(): void;
    // 현재 시스템 로케일이 이거임?(ko, global)
    $isSystemLocale(locale: string): boolean;
    // 카카오챗(상담)
    $kakaoChat(): void;
    // 상품 찜
    $zzimProduct(product: { productCd: number; isZzim: boolean }): AxiosStatic;
    // 모바일임?
    $isMobile: boolean;
    // 뷰 세션
    $session: VueSession;    
    // 뒤로가기
    $goBack(): void;
    // 잘 안쓰는 것들 여기서 끌어씀
    $commonUtils: CommonUtils;

    // 리전 별 통화 String
    mainCurrency: string;
    subCurrency: string;
    mainCurrencyNm: string;
  }
}

declare interface ExceptionMessageVO {
  messageCode: string;
  exceptionName: string;
}

Vue.use(VueOverflowScroll);
Vue.use(VueAwesomeSwiper);
Vue.use(Toast, {
  type: "bottom",
  duration: 3000,
});
Vue.use(infiniteScroll);
Vue.use(VueScrollTo);
Vue.use(VueMeta);
Vue.use(VueKakaoSdk, { apiKey: "15c7a4fd3c35ad60d514f528296b5ef8" });
Vue.use(VueVideoPlayer);
Vue.use(TextareaAutosize);
Vue.component("layout", Layout);
Vue.use(DropdownMenu);
Vue.use(ReadMore);
Vue.use(PortalVue);
Vue.use(VueSession, {
  persist: true
});
Vue.use(VueAnimateOnScroll);
Vue.use(VueGtag,{
  config: {
    id: 'AW-11490382375',
    params:{
      send_page_view: false,
    }
  }
},router);

Vue.mixin({
  data: function () {
    switch (process.env.VUE_APP_SYSTEM_LOCALE) {
      case "ko":
        return { mainCurrency: "원", subCurrency: "$", mainCurrencyNm: "KRW" };
      case "cn":
        return { mainCurrency: "HK$", subCurrency: "约￥", mainCurrencyNm: "HKD" };
      case "global":
      default:
        return { mainCurrency: "US$", subCurrency: "US$", mainCurrencyNm: "USD" };
    }
  },
});

@Component({
  metaInfo() {
    const title = process.env.VUE_APP_TITLE || "";
    return {
      title: title,
      meta: [{ property: "og:title", content: title, vmid: "og:title" }],
    };
  },
})
export default class App extends Vue {

  // 통화 포맷
  get currencyFormat() {
    switch (process.env.VUE_APP_SYSTEM_LOCALE) {
      case "ko":
        return { mainCurrency: "￦", subCurrency: "$", mainCurrencyNm: "KRW", subCurrencyNm: "USD" };
      case "cn":
        return { mainCurrency: "HK$", subCurrency: "约￥", mainCurrencyNm: "HKD", subCurrencyNm: "CNY" };
      case "global":
      default:
        return { mainCurrency: "US$", subCurrency: "US$", mainCurrencyNm: "USD", subCurrencyNm: "USD" };
    }
  }

  // 환율 ( ex: usd / krw )
  get exchangeRate() {
    return CommonUtils.exchangeRateSyncInterval;
  }

  get isMobile() {
    return mobileDeviceDetect.isMobile || CommonUtils.isApp() == true;
  }

  // 마지막 열린 popup component
  getLastPopupComponent(results?: Array<Vue>, _this?): CommonPopup | null {
    results || (results = new Array<Vue>());
    _this || (_this = this);
    _this.$children.forEach((v) => {
      if (v.$children.length > 0) {
        this.getLastPopupComponent(results, v);
      }
      if (results != null && v && v instanceof CommonPopup && v.opened) {
        results.push(v);
      }
    });

    if (!results.length) {
      return null;
    }

    return results[0] as CommonPopup;
  }

  beforeCreate(): void {
    // 세션 조회
    const hasSession: boolean = this.$session.has(Constants.MEMBER_INFO);

    // 없으면 쓸데없이 검사 안함
    if(hasSession == false) {
      return;
    }

    axios.get('/login/ping')
    .then(r => {
      if(r.data as string == 'pong') {
        return;
      }

      // 찌꺼기 제거
      this.$session.destroy();
    });
  }

  created(): void {
    // 앱버전 처리
    axios.get("/common/app-version").then((r) => {
      const appVersion = r.data as string;
      const localAppVersion = localStorage.getItem(Constants.APP_VERSION);
      if (!localAppVersion) {
        // 앱버전이 없으면
        localStorage.setItem(Constants.APP_VERSION, appVersion); // 로컬 스토리지에 넣음
      } else if (localAppVersion != appVersion) {
        localStorage.setItem(Constants.APP_VERSION, appVersion); // 로컬 스토리지에 넣고
        window.location.reload(true); // 강력새로고침
      }
    });

    // 언어 설정
    // let currentCountryCd = localStorage.getItem(Constants.CURRENT_COUNTRY_CD);
    let currentCountryCd = process.env.VUE_APP_I18N_LOCALE;
    if (!currentCountryCd) {
      currentCountryCd = process.env.VUE_APP_I18N_LOCALE || "cn";
      localStorage.setItem(Constants.CURRENT_COUNTRY_CD, currentCountryCd);
    }
    if (currentCountryCd) {
      this.$root.$i18n.locale = currentCountryCd;
      axios.get("/login/ping?lang=" + currentCountryCd);
    }

    axios.interceptors.request.use((config) => {
      //loadProgressBar();
      return config;
    });

    ///////////////////////////
    // 서버 공통 응답
    ///////////////////////////
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (!error.response) {
          // 서버 응답이 지연...
          this.$toast(this.$t("common.a0001"));
          return Promise.reject(error);
        }

        // 서버 Exception Handler와 연계
        let params;
        switch (error.response.status) {
          case 401:
            if ("UsernameNotFoundException" == error.response.data.exceptionName) {
              this.$toast(this.$t("login.a0005")); // 아이디 또는 비밀번호를 확인해 주세요.              
              break;
            }
            // 세션 종료 처리
            alert(this.$t("common.a0003"));
            params = this.$route.params;
            params.toName = this.$route.name as string;
            this.$router.push({ name: "Login", params: params });
            break;
          case 500:
            console.log(error);
            if (!error.response.data) {
              break;
            }
            switch (error.response.data.exceptionName) {
              // 주문 server validation 실패 처리
              case "OrderException":
                alert(this.$t("order.a0007").toString() + this.$t(error.response.data.messageCode, error.response.data.args));

                // 없는 상품
                if (error.response.data.messageCode == "order.a0015") {
                  this.$router.push({ name: "Main" });
                }
                break;
              case "BadCredentialsException":
              case "CountedBadCredentialsException":
                if (error.response.data.args[0] == 1) {
                  this.$toast(this.$t("login.a0005")); // 아이디 또는 비밀번호를 확인해 주세요.
                } else {
                  alert(this.$t("login.a0008", [error.response.data.args[0]])); // 아이디 또는 비밀번호를 {0}회 잘못 입력하셨습니다. 5회 이상 잘못 입력하게 될 경우 로그인이 제한됩니다.
                }
                break;
              case "DisabledException":
                alert(this.$t("login.a0009")); // 아이디 또는 비밀번호를 5회 잘못 입력하셨습니다. 10분 간 로그인이 제한됩니다.
                break;
              case "AccessDeniedException":
                alert(this.$t("common.a0003")); // 세션이 만료되어..
                this.$router.push({ name: "Login" });
                break;
              default:
                error.response.data.messageCode && alert(this.$t(error.response.data.messageCode, error.response.data.args));
                break;
            }
            break;
          default:
            break;
        }
        return Promise.reject(error);
      }
    );

    // number format 필터
    Vue.filter("number", CommonUtils.toNumber);
    // 정수
    Vue.filter("integer", CommonUtils.toInt);
    // 금액 format
    Vue.filter("price", CommonUtils.toPrice);
    // 금액 (HKD -> USD)
    Vue.filter("toSubCurrency", CommonUtils.toSubCurrency);
    // mask
    Vue.filter("idMask", (val: string) => {
      const len = 3;

      if (!val) {
        return "";
      }
      if (val.length <= len) {
        return val;
      }
      // 공식 아이디는 마스킹 안함
      if (["zikoo", "zikoo_inf", "zikoo_editor"].includes(val)) {
        return val;
      }
      return val.substr(0, len) + "*".repeat(len);
    });
    Vue.filter("mainCurrencyPrice", (price: number) => {
      const format = process.env.VUE_APP_SYSTEM_LOCALE == "ko" ? "0,0[.]00" : "0,0.00";
      switch (process.env.VUE_APP_SYSTEM_LOCALE) {
        case "ko":
          return numeral(price).format(format) + this.mainCurrency;
        default:
          return this.mainCurrency + numeral(price).format(format);
      }
    });
    Vue.component("datetime", Datetime);
    Vue.component("discountRate", DiscountRate);
    Vue.component("mainSubCurrency", MainSubCurrency);
    Vue.component("vueSlider", VueSlider);

    // scroll top
    Vue.prototype.$scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    // 현재 로케일이 이거임?
    Vue.prototype.$isSystemLocale = (localeStr: string) => {
      return CommonUtils.isSystemLocale(localeStr);
    };

    // 카카오 채널 연결
    Vue.prototype.$kakaoChat = () => {
      window.open("https://pf.kakao.com/_Gvyyxb/chat", "realNamePop", "height=" + screen.height + ",width=" + screen.width + "fullscreen=yes");
      window.close();
    };
    // 상품 찜하기
    Vue.prototype.$zzimProduct = CommonUtils.zzimProduct;
    // 모바일임?
    Vue.prototype.$isMobile = this.isMobile;
    // 뒤로가기
    Vue.prototype.$goBack = CommonUtils.goBack;

    // 잘 안쓰는건 그냥 여기서 끌어쓰면 됨
    Vue.prototype.$commonUtils = CommonUtils;
  }

  mounted(): void {
    const element = document.getElementById("splash");
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
    CommonUtils.getExchangeRate();

    // 앱 뒤로가기 버튼(팝업이 있으면 팝업을 닫고, 아니면 뒤로 가기)
    window.addEventListener("rnBack", () => {
      const popup = this.getLastPopupComponent();
      if (popup) {
        popup.closePop();
      }
      // 앱
      else if (CommonUtils.isApp()) {
        // 메인화면에서 2번 누르면 앱 종료
        if (this.$route.name == "Main") {
          window["webViewBridge"].send("exitApp", { queryString: "" }, null);
          return;
        }
        this.$router.go(-1);
        // 모바일웹
      } else {
        this.$router.go(-1);
      }
    });

    // FCM 토큰 저장
    if (CommonUtils.isApp() == true) {
      // 토큰 저장 여부 확인
      const savedFcmUserToken = CommonUtils.getLocalStorageObject(Constants.SAVED_FCM_USER_TOKEN);

      if (savedFcmUserToken != null && savedFcmUserToken.saved == true) {
        return;
      }

      // 토큰 저장
      axios.put("/member/fcm-user-token").then((r) => {
        if (!r.data) {
          return;
        }

        // 토큰 저장 여부 저장
        CommonUtils.putLocalStorageObject(Constants.SAVED_FCM_USER_TOKEN, { saved: true });
      });
    }

    // 장바구니
    this.$store.dispatch("updateCartCount");

    // 로그인 세션
    CommonUtils.setMemberInfoToSession();    

    // 최근 본 상품정보 목록
    this.$store.commit('recentProductInfo', CommonUtils.getLocalStorageObject(Constants.RECENT_PRODUCTS_INFO) as Array<RecentProductVO>);
  
  }

}
